import { put, takeLatest, fork, call } from "redux-saga/effects";

import {
  ActionType,
  UserListBusinessPayload,
  UserListBusinessResponse,
} from "models/userListBusiness/usersListBusiness";
import { httpStatus } from "configs/httpStatus";
import { getUserListBusiness } from "services/userListBusiness";

import {
  handleSuccesAction,
  handleErrorAction,
} from "./usersListBusinessActions";

function* userListBusinessSaga({
  payload,
}: {
  payload: UserListBusinessPayload;
}) {
  try {
    const response: UserListBusinessResponse = yield call(
      getUserListBusiness,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onGetUserListBusinessWatcher() {
  yield takeLatest(ActionType.USER_LIST_BUSINESS as any, userListBusinessSaga);
}

export default [fork(onGetUserListBusinessWatcher)];
